import React from "react";
import { AiFillGithub, AiOutlineLink } from "react-icons/ai";
import { FiExternalLink } from "react-icons/fi";
import { motion } from "framer-motion";

function Product({ title, link, desc, site, tech1, img, embed }) {
  return (
    <motion.a
      href={link}
      target="_blank"
      whileHover={{ scale: 1.01 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className=" sm:h-[220px] w-full flex sm:flex-row flex-col gap-4 rounded-xl p-2 glass cursor-pointer"
    >
      <motion.div className="w-full sm:w-[40%]">
        <motion.img src={img} className="h-[200px] w-full rounded-md" />
      </motion.div>

      <div className="flex flex-col gap-2 w-full sm:w-[60%]">
        <h1 className="text-[25px] flex items-center gap-2">
          {title}{" "}
          <span>
            <AiOutlineLink />
          </span>
        </h1>
        <p className="text-[14px]">{desc}</p>
        <p className="tech text-[14px]">{tech1}</p>
      </div>
    </motion.a>
  );
}

export default Product;
